import { useLayoutEffect } from 'react';

import { matchPath, Navigate, Outlet, RouterUtils, useLocation } from 'application/providers/RouterProvider';
import { LOGIN_PAGE_PATH } from 'application/consts';
import { useAppSelector } from 'application/providers/StoreProvider';
import { selectIsAuthorized } from 'application/store';

import { AVAILABLE_TO_REDIRECT_PATHS } from './consts';

const PrivateRoute = () => {
  const hasAccess = useAppSelector(selectIsAuthorized);

  const location = useLocation();

  useLayoutEffect(() => {
    if (!hasAccess) {
      const isMatch = AVAILABLE_TO_REDIRECT_PATHS.find((path) => matchPath({ path, end: false }, location.pathname));

      if (isMatch) {
        RouterUtils.setTargetPathname(location.pathname);
      }
    }
  }, []);

  return hasAccess ? (
    <Outlet />
  ) : (
    <Navigate
      to={LOGIN_PAGE_PATH}
      replace
    />
  );
};

export default PrivateRoute;
